module.exports = __webpack_public_path__ + "static/media/arrow.73832f61.svg";